import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';

import Home from './pages/Home';
import SvCodeCracker from "@/calculators/SvCodeCracker.tsx";
import TerminusCodeCracker from "@/calculators/TerminusCodeCracker.tsx";
import BotLobby from './pages/BotLobby'; // placeholder for now
import GuideViewer from './components/GuideViewer';

function App() {
    const [darkMode, setDarkMode] = useState(() => {
        const stored = localStorage.getItem('darkMode');
        return stored ? JSON.parse(stored) : false;
    });

    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(darkMode));
    }, [darkMode]);

    return (
        <Router>
            <Routes>
                <Route element={<Layout darkMode={darkMode} toggleDarkMode={() => setDarkMode((prev: boolean) => !prev)} />}>
                    <Route path="/" element={<Home darkMode={false} />} />
                    <Route path="/calculators/sv" element={<SvCodeCracker darkMode={darkMode} />} />
                    <Route path="/calculators/terminus" element={<TerminusCodeCracker darkMode={darkMode} />} />
                    <Route path="/lobby" element={<BotLobby darkMode={darkMode} />} />
                    <Route path="/guides/:slug" element={<GuideViewer darkMode={darkMode} />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;